import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as questionnaireAdminActions from '../../ducks/questionnaire-admin'

import WopiInvitationError from './../WopiInvitationError'

function mapStateToProps(state) {
  return {
    error: state.questionnaireAdmin.get('invitationError')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    onDismissError: () =>
      bindActionCreators(questionnaireAdminActions, dispatch).setInvitationError(null)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WopiInvitationError)



// WEBPACK FOOTER //
// ./src/components/smart/WopiInvitationErrorContainer.js